/** Generate Image — aspect-ratio choice incl. "自由比例（由提示词决定）" (VistoeraTASK-00498).
 *
 * `FREE_RATIO` is a UI/node-field sentinel ONLY. Its canonical meaning is
 * **NO aspect-ratio constraint**: it must never reach the request / Worker /
 * provider as `"free"`, `"auto"`, `null` or a substituted `1:1`. The submit
 * payload simply OMITS `ratio` (see `ratioForSubmit` +
 * `buildImageGenerationSubmitPayload`), and the Control Plane in turn omits it
 * from the Worker payload.
 *
 * Compatibility: a node with no saved ratio reads as free; a node that saved
 * an explicit ratio (`1:1`, `16:9` …) keeps it — never auto-migrated.
 */

export const FREE_RATIO = 'free' as const

export const FIXED_RATIO_VALUES = ['1:1', '4:3', '3:4', '16:9', '9:16'] as const

export type FixedImageRatio = (typeof FIXED_RATIO_VALUES)[number]

/** Normalise a persisted `fields.ratio` into the UI choice. */
export function resolveRatioChoice(raw: unknown): string {
  if (typeof raw !== 'string') return FREE_RATIO
  const v = raw.trim()
  if (!v || v.toLowerCase() === FREE_RATIO) return FREE_RATIO
  return v
}

export function isFreeRatio(choice: unknown): boolean {
  return resolveRatioChoice(choice) === FREE_RATIO
}

/** The ratio to send to the backend — `undefined` (omit) for free ratio. */
export function ratioForSubmit(choice: unknown): string | undefined {
  const v = resolveRatioChoice(choice)
  return v === FREE_RATIO ? undefined : v
}

/** Ratio for pure layout / placeholder maths — free falls back to square. */
export function ratioForLayout(choice: unknown): string {
  return ratioForSubmit(choice) ?? '1:1'
}
